import styled from "styled-components";

import { sizes } from "shared/utils/styles";

import breakpoints from "shared/utils/breakpoints";
import BreakPoints from "shared/utils/Breakpoint";

type PColor = {
  color: string;
};

export const Container = styled.div`
  /* margin-top: 2rem; */
  padding: 2rem 0;
  /* border: 1px solid red; */

  @media (${BreakPoints.xs}) {
    position: relative;
    top: -4.45rem;
    padding: 0 0.5rem;
  }
`;

export const BoxContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
export const Tbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
`;

export const TboxColor = styled.div<PColor>`
  width: 14px;
  height: 14px;
  background-color:${(props) => props.color}
  border-radius: 4px;
`;

export const TBoxText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  padding-top: 3.5px;
`;
